@if (errorTitle) {
<h1 class="error-page-title">
  {{ errorTitle }}
</h1>
} @if (perex) {
<h4 class="error-page-perex">
  {{ perex }}
</h4>
} @if (text) {
<p class="error-page-text">
  {{ text }}
</p>
} @if (image && errorTitle) {
<div>
  <img [src]="image" [alt]="errorTitle" class="error-page-image" />
</div>
}
<ng-content></ng-content>
